import { observable } from 'mobx';
import { IStateTreeNode } from 'mobx-state-tree';

// 인터페이스
export interface IPagination {
  page: number;
  size: number;
  offset: number;
  numberOfElements: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

// 초기값
export const INIT_PAGINATION: IPagination = {
  page: 1,
  size: 20,
  offset: 0,
  numberOfElements: 0,
  totalElements: 0,
  totalPages: 1,
  first: true,
  last: true,
};

export type TPageParams = {
  page: number;
  size: number;
};

// 페이지 사이즈 옵션
export const ROWS_PER_PAGE_OPTIONS = [
  { value: 20, label: '20 / page' },
  { value: 50, label: '50 / page' },
  { value: 100, label: '100 / page' },
];

export const DEFAULT_PAGE_SIZE = 20;
export const withPagination = <T extends IStateTreeNode>(_self: T) => {
  const pageInfo = observable.box<IPagination>({ ...INIT_PAGINATION });

  return {
    views: {
      get paginationRaw() {
        return pageInfo;
      },
      get pagination() {
        return pageInfo.get();
      },
      get isFirst() {
        return pageInfo.get().first;
      },
      get isLast() {
        return pageInfo.get().last;
      },
      get page() {
        return pageInfo.get().page;
      },
      get size() {
        return pageInfo.get().size;
      },
      get offset() {
        return pageInfo.get().offset;
      },
      get numberOfElements() {
        return pageInfo.get().numberOfElements;
      },
      get totalElements() {
        return pageInfo.get().totalElements;
      },
      get totalPages() {
        return pageInfo.get().totalPages;
      },
    },

    actions: {
      setSize(size: number) {
        pageInfo.set({
          ...pageInfo.get(),
          size,
        });
      },

      setPage(page: number) {
        pageInfo.set({
          ...pageInfo.get(),
          page,
        });
      },

      resetPagination(props: Partial<IPagination> = {}) {
        pageInfo.set({ ...INIT_PAGINATION, ...props });
      },

      setPagination(newPagination?: IPagination) {
        if (newPagination) {
          pageInfo.set({ ...newPagination });
        } else {
          pageInfo.set({ ...INIT_PAGINATION });
        }
      },

      updatePagination(newPagination: Partial<IPagination>) {
        pageInfo.set({
          ...pageInfo.get(),
          ...newPagination,
        });
      },
    },
  };
};
